import { createClient } from '@supabase/supabase-js';
const SUPABASE_URL = 'https://pcalgasfnvmabmcymlhj.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBjYWxnYXNmbnZtYWJtY3ltbGhqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA2NTI2MzcsImV4cCI6MjA5NjIyODYzN30.DJVQNvSzE5akJ-UaCyzfLSDpqhlBr_aMwRNc-VDM8_M';
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
